import { render } from "./UserVersesQuotes.vue?vue&type=template&id=a3618df0"
import script from "./UserVersesQuotes.vue?vue&type=script&lang=js"
export * from "./UserVersesQuotes.vue?vue&type=script&lang=js"

import "./UserVersesQuotes.vue?vue&type=style&index=0&id=a3618df0&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__